export default {
  data () {
    return {
      syncDataInterval: null,
      syncDataIntervalRunTime: 0
    }
  },
  methods: {
    getBackendFullUrl (path) {
      if (!path) return path;
      const backendUrl = process.env.VUE_APP_BACK_END_URL;
      return backendUrl + '/' + path.replace(backendUrl + '/', '') + '?ts=' + new Date().getTime();
    },
    removeBackendHost (path) {
      if (path.indexOf('http://') > -1 || path.indexOf('https://') > -1) {
        path = (path.replace('http://', '').replace('https://'));
        let pathArray = path.split('/');
        pathArray.shift();
        path = pathArray.join('/');
      }
      return path;
    },
    getBackendRelativeUrl (path) {
      if (!path) return path;
      const backendUrl = process.env.VUE_APP_BACK_END_URL;
      return path.replace(backendUrl + '/', '');
    },
    syncData ({ sync, checkIsFinished, time = 20000, maxRunTime = 10 }) {
      // Reset interval
      this.syncDataIntervalRunTime = 0;
      clearInterval(this.syncDataInterval);

      this.syncDataInterval = setInterval(async () => {
        await sync();

        if (checkIsFinished() || this.syncDataIntervalRunTime === maxRunTime) {
          clearInterval(this.syncDataInterval);
        }
        this.syncDataIntervalRunTime++;
      }, time);
    },
    getBrowserName () {
      let userAgent = window?.navigator?.userAgent || '';

      if(userAgent.match(/chrome|chromium|crios/i)) return "chrome";
      if(userAgent.match(/firefox|fxios/i)) return "firefox";
      if(userAgent.match(/safari/i)) return "safari";
      if(userAgent.match(/opr\//i)) return "opera";
      if(userAgent.match(/edg/i)) return "edge";

      return "unknown";
    }
  },
  beforeDestroy() {
    clearInterval(this.syncDataInterval);
  }
}
